"use client";

import Accordion from "@JohnLewisPartnership/jl-design-system/dist/components/accordion/Accordion";
import styles from "./HowToUseAccordion.module.scss";
import { cleanHtml } from "../../../../utils/string/cleanHtml";

type Props = {
  open?: boolean;
  howtoUseContent: string | null | undefined;
};

export const PRODUCT_HOW_TO_USE_ACCORDION_INSTANCE_NAME = "how-to-use";

export function ProductHowToUseAccordionUI({ open, howtoUseContent }: Props) {
  if (!howtoUseContent) {
    return null;
  }

  return (
    <Accordion
      id="accordion-how-to-use"
      className={styles["product-accordion__item"]}
      data-testid="accordion:how-to-use"
      label="How to use"
      animated={true}
      instanceName={PRODUCT_HOW_TO_USE_ACCORDION_INSTANCE_NAME}
      responsive
      open={open}
    >
      <div
        data-testid="howToUse:Description"
        className={styles.productDescriptionBody}
        dangerouslySetInnerHTML={{ __html: cleanHtml(howtoUseContent) || "" }}
      />
    </Accordion>
  );
}
